import React, { PropTypes } from "react";

import VirtualizedSelect from "react-virtualized-select";

import { FormattedMessage } from "react-intl";
import { LIKE, EQUALS } from "../GraphQL/GraphQLFilterTypes";

class SelectHeaderV2 extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchValue: null,
            currentFilter: "",
            emptyReq: false,
            activeSelectedItems: false,
            previousSearch: null,
            removeItemClick: false,
            currentSelectedItems: [],
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.setCurrentFilter = this.setCurrentFilter.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        const { colProps } = this.props;
        const { searchValue } = this.state;
        if (this.state.searchValue != prevState.searchValue) {
            this.setState({ previousSearch: prevState.searchValue });
        }
        if (
            prevProps.colProps.filterList &&
            prevProps.colProps.filterList.length > 0 &&
            colProps.filterList.length === 0 &&
            searchValue &&
            searchValue.length === 0
        ) {
            this.setState({ removeItemClick: true });
        }
    }

    handleChange(val) {
        const { onChange, setActiveCol, colProps } = this.props;
        const { activeSelectedItems, previousSearch, searchValue } = this.state;

        this.setState({ removeItemClick: val.length < this.state.currentSelectedItems.length || val.length === 0 });
        /**
         * If true, it means a filter in the column was removed using the X button. (val contains current state of the column),
         * but we need to use a state in the component to keep track of what the selected items were before the handleChange function is triggered.
         */

        this.setState({ currentSelectedItems: val });
        /**
         * After we check if filters were removed, we set the currentSelectedItems state to the current state of the column.
         */

        let emptyFilter = false;
        /**
         * Variable used to determine if we should empty the list of dropdown options
         */

        if (searchValue === "") {
            emptyFilter = true;
        }

        if (activeSelectedItems && val.length == 0) {
            setActiveCol(colProps.col, true);
            this.setState({
                activeSelectedItems: false,
                currentSelectedItems: [],
            });
            emptyFilter = true;
        }

        if (!activeSelectedItems && val.length > 0) {
            setActiveCol(colProps.col, false);
            this.setState({
                activeSelectedItems: true,
            });
        }

        if (previousSearch && searchValue === "") {
            this.setState({ previousSearch: null });
        }

        onChange(val, emptyFilter);
    }

    handleBlur() {
        const {
            searchValue,
            currentFilter,
            emptyReq,
            activeSelectedItems,
            previousSearch,
            removeItemClick,
        } = this.state;
        const { asyncColSearch, colProps, frontFilter, isGraphQL } = this.props;

        if (searchValue !== null && searchValue.length === 0) {
            /**
             * We don't want to treat any onBlur events, unless searchValue is empty.
             */
            if (!removeItemClick && ((emptyReq && !activeSelectedItems) || (previousSearch && searchValue === ""))) {
                const splitPattern = isGraphQL ? LIKE : EQUALS;
                let filterValue = colProps.modelName + "." + colProps.col + splitPattern + searchValue;
                /**
                 * Async search filter should always be "=like=" for graphql since we are doing a text search for a particular value.
                 */

                asyncColSearch(filterValue, currentFilter, this.setCurrentFilter, colProps, frontFilter);
                this.setState({ emptyReq: false });

                if (previousSearch) {
                    this.setState({ previousSearch: null });
                }
            }
        }
    }

    setCurrentFilter(val) {
        this.setState({ currentFilter: val });
    }

    onInputChange(input) {
        const { minimumQueryLength, setActiveCol, colProps } = this.props;
        const sanitizedInput = this.sanitizeCharEscapes(input);
        const isQueryInactive = sanitizedInput === "" || sanitizedInput.length < minimumQueryLength;
        /** This check allows us to check if a query should be emptied (which starts a query without the col's filter) */

        this.setState({
            searchValue: sanitizedInput,
            emptyReq: isQueryInactive,
        });

        if (!isQueryInactive) {
            /** If user is typing, he's not removing any item, so we can reset this state. */
            this.setState({ removeItemClick: false });
        }

        setActiveCol(colProps.col, isQueryInactive);

        return input;
    }

    sanitizeCharEscapes(val) {
        val = val.replace(/;/g, "_sc_"); // SC = semicolon.
        return val;
    }

    handleKeyDown(e) {
        if (e.keyCode == 13) {
            /** Keycode 13 = Enter key */
            const { searchValue } = this.state;
            const { asyncColSearch, colProps, frontFilter, isGraphQL, minimumQueryLength } = this.props;

            e.preventDefault();
            e.stopPropagation();
            /** This disables all actions done by the Enter button. By doing this we can completely control what the enter button does (async call in this case). */

            if (searchValue.length > 0) {
                /**
                 * If user filled the field with words, and presses enter, he's not removing anything, so we can set this to false.
                 */
                this.setState({ removeItemClick: false });
            }

            if ((searchValue && searchValue.length >= minimumQueryLength) || searchValue === "") {
                const splitPattern = isGraphQL ? LIKE : EQUALS;
                let filterValue = colProps.modelName + "." + colProps.col + splitPattern + this.state.searchValue;
                /**
                 * Async search filter should always be "=like=" for graphql since we are doing a text search for a particular value.
                 */

                asyncColSearch(filterValue, this.state.currentFilter, this.setCurrentFilter, colProps, frontFilter);
            }
        }
    }

    render() {
        const { colProps, placeholder, searchable, customMenuClassName } = this.props;

        return (
            <div className={`virtualized-char-limit ${customMenuClassName}`}>
                <VirtualizedSelect
                    className="select-header"
                    onChange={(e) => this.handleChange(e)}
                    value={colProps.items}
                    onInputChange={(input) => this.onInputChange(input)}
                    noResultsText={<FormattedMessage id="asyncSearchMessage" />}
                    multi={true}
                    autosize={true}
                    autofocus={false}
                    searchable={searchable}
                    clearable={true}
                    removeSelected={true}
                    onCloseResetsInput={false}
                    onBlurResetsInput={false}
                    onBlur={this.handleBlur}
                    labelKey={colProps.col}
                    valueKey={colProps.key}
                    onInputKeyDown={this.handleKeyDown}
                    placeholder={placeholder}
                    options={colProps.filterList ? colProps.filterList : []}
                />
            </div>
        );
    }
}

SelectHeaderV2.propTypes = {
    onChange: PropTypes.func.isRequired,
    colProps: PropTypes.object.isRequired,
    placeholder: PropTypes.object,
    asyncSearch: PropTypes.object,
    frontFilter: PropTypes.bool,
    isGraphQL: PropTypes.bool,
    minimumQueryLength: PropTypes.number,
    searchable: PropTypes.bool,
    setActiveCol: PropTypes.func.isRequired,
    asyncColSearch: PropTypes.func,
    customMenuClassName: PropTypes.string,
};

export default SelectHeaderV2;



// WEBPACK FOOTER //
// ./src/components/common/DataTableV2/SelectHeaderV2.js